<template>
  <!-- 申请发票 -->
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    append-to-body
    :destroy-on-close="true"
    title="退保订单信息"
    width="60%"
  >
  <div class="title">退保订单信息</div>
    <el-descriptions
      class="margin-top"
      :column="2"
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
      border
    >
      <el-descriptions-item>
        <template slot="label"> 订单号： </template>
        {{ form.orderNum }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 项目名称： </template>
        {{ form.projectName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 保证金金额： </template>
        {{ form.guaMoney }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 标段名称： </template>
        {{ form.bidName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 订单金额： </template>
        {{ form.orderFee }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 申请时间： </template>
        {{ form.orderCreateTime }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="title">退保订申请详情</div>
    <el-descriptions
      class="margin-top"
      :column="2"
      border
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
    >
      <el-descriptions-item>
        <template slot="label"> 经办人： </template>
        {{ form.handlerName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 退保申请时间： </template>
        {{ form.refundCreateTime }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="margin-top"
      :column="1"
      border
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
    >
      <el-descriptions-item>
        <template slot="label"> 经办人手机： </template>
        {{ form.handlerPhone }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 退保理由： </template>
        {{ form.reason }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="title">发票信息</div>
    <el-descriptions
      class="margin-top"
      :column="2"
      border
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
    >
      <el-descriptions-item>
        <template slot="label"> 退保状态： </template>
        <span v-show="form.refundStatus == '6'">待退保</span>
        <span v-show="form.refundStatus == '7'">已退保</span>
        <span v-show="form.refundStatus == '8'">退保失败</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 退款时间： </template>
        {{ form.refundTime }}
      </el-descriptions-item>
      <el-descriptions-item >
        <template slot="label"> 退保失败理由： </template>
        <div style="color: #ff0f08;">{{ form.objection }}</div>
      </el-descriptions-item>
    </el-descriptions>
    <div style="text-align: center; margin-top: 52px;">
      <el-button
        type='info'
        @click="back"
        >关闭</el-button
      >
    </div>
    <!-- </el-form> -->
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import { getDetailedRefund } from "../../apis/project/index";
export default {
  data() {
    return {
      ordinary: false,
      special: false,
      // refundId: this.$route.query.refundId,
      refundId:'',
      form: {},
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Number,
      default: null,
    },
  },
  watch: {
    formData: {
      handler(v) {
        if (v) {
          this.refundId = v;
          this.Query();
        }
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(v) {
        this.$emit("update:dialogVisible", v);
      },
    },
  },
  methods: {
    typeOne() {
      this.special = false;
      this.ordinary = !this.ordinary;
    },
    typeTwo() {
      this.ordinary = false;
      this.special = !this.special;
    },
    back() {
      // this.$router.push("/surrender");
      this.visible = false
    },
    onSubmit() {
      this.$message({
        message: "提交成功",
        type: "success",
      });
      this.$router.push("/invoice");
    },
    Query() {
      getDetailedRefund({ refundId: this.refundId }).then((res) => {
        this.form = res.data.data;
      });
    },
  },
  mounted() {
  },
  components: {},
};
</script>

<style scoped>
.page {
  background-color: #fff;
  height: 100%;
  margin: 0 20px;
}
.elCard {
  background-color: #0065b3 !important;
  color: #fff;
}
::v-deep .el-dialog__title {
  border-left: 5px solid #3b7df9;
  padding-left: 10px;
  font-weight: bold;
}
.margin-top{
  margin: 20px 0;
}
</style>
